module.exports = __webpack_public_path__ + "static/media/lucky.1d554488.png";